var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.755 6.366-6.14 6.292q-.376.385-.877.37a1.25 1.25 0 0 1-.877-.402 1.37 1.37 0 0 1-.36-.899q-.015-.513.36-.899l8.27-8.475q.188-.193.407-.273.22-.08.47-.08t.47.08.407.273l8.27 8.475q.345.354.345.883 0 .53-.345.915-.376.385-.892.385-.518 0-.893-.385l-6.109-6.26v14.35q0 .546-.36.915t-.893.369-.893-.37a1.26 1.26 0 0 1-.36-.914z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.a74a189c4a17bf4b791812c98630da30.svg";
export { ForwardRef as ReactComponent };